export default __webpack_public_path__ + "static/media/work_and_learn.4e62192f.jpg";